import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class CallStartService {
	private config: Config = inject(Config);
	private router: Router = inject(Router);
	
	windowParams: Array<any> = [
		'height=' + screen.availHeight,
		'width=' + screen.availWidth,
		'fullscreen=yes', // for IE
		'menubar=no',
		'status=no',
		'titlebar=no',
		'top=0',
		'left=0'
	];
	
	// TODO: save window to variable and close it when another call comes in (window.close())
	startCall(userId) {
		this.openCall(this.config.getCallConfig().CALL_TYPE.OUTGOING, userId);
	}
	
	startBusinessCall(userId, bookingId) {
		this.openCall(this.config.getCallConfig().CALL_TYPE.OUTGOING, userId, { bookingId: bookingId });
	}
	
	startBusinessCallForConsultant(userId) {
		this.openCall(this.config.getCallConfig().CALL_TYPE.OUTGOING, userId, { consultant: true });
	}
	
	startBusinessTestCall() {
		this.openCall(this.config.getCallConfig().CALL_TYPE.OUTGOING, 'null', { testCall: true });
	}
	
	// TODO: save window to variable and close it when another call comes in (window.close())
	answerCall(userId) {
		this.openCall(this.config.getCallConfig().CALL_TYPE.INCOMING, userId);
	}

	openCall(type, userId, additionalParams?) {
		var primaryRoute: any = (this.router.url || '/').split('?')[0];
		primaryRoute = primaryRoute.replace(/\(fullscreen:call\)/, '');
		var callRoute: any = primaryRoute === '/'
			? '/(fullscreen:call)'
			: primaryRoute + '(fullscreen:call)';
		var queryParams: any = Object.assign({ type: type, uid: userId }, additionalParams || {});
		var query: any = Object.keys(queryParams)
			.map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]))
			.join('&');
		var popup: any = window.open('#' + callRoute + '?' + query, '', this.windowParams.join(','));
		this.goToFullScreen(popup);
	}
	
	goToFullScreen(element) {
		element.moveTo(0, 0);
		element.resizeTo(screen.availWidth, screen.availHeight);
		// var reqfs = element.requestFullscreen || element.mozRequestFullScreen || element.webkitRequestFullscreen || element.msRequestFullscreen;
		// if ( reqfs ) {
			// 	reqfs();
		// }
	}
	
}
